import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import VnButton from '@ui/components/VnButton';
import { addOutline } from 'ionicons/icons';
import ModalPopup from '@ui/components/VnModal';
import AddAttachmentsForm from './AddAttachmentsForm';
import { useState } from 'react';
import AttachmentsTable from './AttachmentsTable';
import { Permission, PermissionType } from '@application/common/enums/role-permission';
import { handleRolePermission } from '@infrastructure/helpers';
import { useAppDispatch } from '@application/store/useStore';
import { resetTimer, setModuleLock, unsetModuleLock } from '@application/features/workorders/workorderSlice';
import { VisserModule } from '@application/common/enums/visser-module';
import { updateModulePermissionsStatusAsync } from '@application/features/workorders/workorderThunk';
const AttachmentsTab = ({ formData, errors, onFieldChange, onCalendarChange, disableRecord, isAttachmentTabBold }) => {
    const [isOpen, SetIsOpen] = useState(false);
    const dispatch = useAppDispatch();
    function oncloseClicked() {
        SetIsOpen(false);
    }
    const handleButtonClick = async () => {
        var moduleLockStatus = await checkModulelock();
        if (moduleLockStatus == false) {
            SetIsOpen(true);
        }
    };
    //-------------------Module Lock Functionality---------------------------
    const checkModulelock = async () => {
        if (formData.id) {
            dispatch(resetTimer());
            var moduleLockRequestData = {
                moduleId: VisserModule.Bestellingen,
                recordId: formData.id
            };
            try {
                const res = await dispatch(updateModulePermissionsStatusAsync(moduleLockRequestData)).unwrap();
                if (res.isModuleAlreadyLocked) {
                    dispatch(setModuleLock());
                    return true;
                }
                dispatch(unsetModuleLock());
                return false;
            }
            catch (error) {
                dispatch(unsetModuleLock());
                return false;
            }
        }
        return false;
    };
    return (_jsxs(_Fragment, { children: [_jsx("div", { className: 'Vn-supplier-attachments-button', children: _jsx("div", { children: _jsx(VnButton, { type: 'button', mode: 'primary', size: 'sm', customClassName: 'vn-add-button', icon: addOutline, onClick: handleButtonClick, isDisabled: !handleRolePermission(Permission.BESTELLINGEN, PermissionType.Create) || disableRecord, children: "Toevoegen Bijlagen" }) }) }), _jsx("div", { className: 'mt-3', children: _jsx(AttachmentsTable, { formData: formData, isAttachmentTabBold: isAttachmentTabBold }) }), _jsx(ModalPopup, { title: 'Upload bestanden', content: _jsx(AddAttachmentsForm, { onClose: oncloseClicked, formData: formData, isAttachmentTabBold: isAttachmentTabBold }), onOpen: isOpen, onClose: () => oncloseClicked(), modalWidth: 'lg' })] }));
};
export default AttachmentsTab;
